export { default as ScaleButtonAnimation } from './ScaleButtonAnimation';
